module.exports = __webpack_public_path__ + "img/no-internet.d1dac018.svg";